import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '@components/protected-route/protected-route.component';
import { screens } from '@views/index';
import LoginView from '@views/login/login.view';
import NotFoundView from '@views/not-found/not-found.view';
import PasswordRecoveryView from '@views/password-recovery/password-recovery.view';
import AuthProvider from '@providers/auth-provider';
import { BasicConfigProvider } from '@providers/basic-config-provider';
import { generateUUID } from '@utils/uuid.util';
import { DependencyProvider } from '@providers/dependency-provider';

import styles from './app.module.scss';

const App = () => {
    return (
        <main id={styles.app}>
            <DependencyProvider>
                <AuthProvider>
                    <BasicConfigProvider>
                        <Routes>
                            <Route path="login" element={<LoginView />} />
                            <Route
                                path="password-recovery"
                                element={<PasswordRecoveryView />}
                            />
                            {/* Authenticated routes*/}
                            <Route element={<ProtectedRoute />}>
                                {screens.map((screen) => (
                                    <Route
                                        key={generateUUID()}
                                        path={screen.path}
                                        element={screen.element}
                                    />
                                ))}
                            </Route>
                            <Route path={'*'} element={<NotFoundView />} />
                        </Routes>
                    </BasicConfigProvider>
                </AuthProvider>
            </DependencyProvider>
        </main>
    );
};

export default App;
